import { Field } from '@mfe-types/field';
import { IFields } from '@mfe-types/form';

export const setFieldOptions = (field: Field, fieldValues: IFields) => {
    if ('options' in field) {
        const options = { ...field.options };

        if (typeof field.options?.values === 'function') {
            options.values = field.options.values(fieldValues);
        } else {
            options.values = field.options.values;
        }
        if (Object.keys(options).length) return options;
    }
    return null;
};
